import * as S from './storage';

type FetchType = (url: string, options?: RequestInit) => Promise<Response>;

export default class Fetcher {
    baseUri: string;

    fetch: FetchType;

    constructor(baseUri: string, fetch?: FetchType) {
        this.baseUri = baseUri;
        this.fetch = fetch || Fetcher.fetch;

        this.fetchFolders = this.fetchFolders.bind(this);
        this.fetchMinimalFavoriteMap = this.fetchMinimalFavoriteMap.bind(this);
        this.addToFolder = this.addToFolder.bind(this);
        this.removeFromFolder = this.removeFromFolder.bind(this);
        this.createFolder = this.createFolder.bind(this);
        this.deleteFolder = this.deleteFolder.bind(this);
        this.fetchNumFavs = this.fetchNumFavs.bind(this);
    }

    static fetch(url: string, options?: RequestInit): Promise<Response> {
        return window.fetch(url, options);
    }

    static getCredentialsHeader(): RequestCredentials {
        const { host } = window.location;
        if (host.includes('local.finn.no')) {
            return 'include';
        }
        return 'same-origin';
    }

    fetchMinimalFavoriteMap(): Promise<Response> {
        return this.fetch(`${this.baseUri}/minimal`, {
            credentials: Fetcher.getCredentialsHeader(),
        });
    }

    addToFolder(
        itemType: S.ItemType,
        itemId: number,
        folderId: number,
    ): Promise<Response> {
        return this.fetch(`${this.baseUri}/${folderId}/${itemType}/${itemId}`, {
            credentials: Fetcher.getCredentialsHeader(),
            method: 'PUT',
        });
    }

    removeFromFolder(
        itemType: S.ItemType,
        itemId: number,
        folderId: number,
    ): Promise<Response> {
        return this.fetch(`${this.baseUri}/${folderId}/${itemType}/${itemId}`, {
            credentials: Fetcher.getCredentialsHeader(),
            method: 'DELETE',
        });
    }

    fetchFolders(): Promise<Response> {
        return this.fetch(this.baseUri, {
            credentials: Fetcher.getCredentialsHeader(),
        });
    }

    createFolder(name: string): Promise<Response> {
        return this.fetch(`${this.baseUri}`, {
            credentials: Fetcher.getCredentialsHeader(),
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ name }),
        });
    }

    deleteFolder(folderId: number): Promise<Response> {
        return this.fetch(`${this.baseUri}/${folderId}`, {
            credentials: Fetcher.getCredentialsHeader(),
            method: 'DELETE',
        });
    }

    fetchNumFavs(itemType: S.ItemType, itemId: number): Promise<Response> {
        return this.fetch(`${this.baseUri}/${itemType}/${itemId}/counter`, {
            credentials: Fetcher.getCredentialsHeader(),
        });
    }
}
